import React from 'react';

interface VeraWordmarkProps {
  /** Approximate cap height in px; drives the font size. */
  size?: number;
  className?: string;
  color?: string;
}

/**
 * VERA brand wordmark — the app's identity mark.
 * All-caps, bold, letter-spaced, in the app's primary font.
 * Replaces the legacy eye logo.
 */
export const VeraWordmark: React.FC<VeraWordmarkProps> = ({
  size = 32,
  className = '',
  color = 'var(--color-primary)',
}) => {
  return (
    <span
      className={`vera-wordmark ${className}`}
      style={{
        fontFamily: 'var(--font-family-base, inherit)',
        fontWeight: 800,
        fontSize: `${size}px`,
        letterSpacing: '0.08em',
        lineHeight: 1,
        color,
        textTransform: 'uppercase',
      }}
      aria-label="VERA"
    >
      VERA
    </span>
  );
};
